module.exports = __webpack_public_path__ + "static/media/for-sale-amico-building.1f8e1f96.svg";